import last from 'lodash/last';

/** *******************Select************************** */

/** *******************Panel************************** */
const loop = (data, code, callback) => {
  data.forEach((item, index, arr) => {
    if (item.code === code) {
      return callback(item, index, arr);
    }
    if (item.categories) {
      return loop(item.categories, code, callback);
    }
    return null;
  });
};

export function buildSelectedData(data, selectedCodes) {
  if (!data || !data.code) {
    return {};
  }
  if (!selectedCodes || !selectedCodes.length) {
    return data;
  }
  const selectedCode = last(selectedCodes);
  let selectedData = null;
  loop([data], selectedCode, (item) => {
    selectedData = item;
  });
  return selectedData;
}

export function buildBreadcrumbData(data, selectedCodes) {
  if (!data || !data.code) {
    return null;
  }
  const codes = [data.code, ...selectedCodes];
  const breadcrumbData = [];
  codes.forEach((code) => {
    loop([data], code, (item) => {
      breadcrumbData.push({
        code: item.code,
        name: item.name,
      });
    });
  });
  return breadcrumbData;
}

export function buildSelectedCodes(selectedCodes, code) {
  const index = selectedCodes.indexOf(code);
  return selectedCodes.slice(0, index + 1);
}

export function getSearchResult(data) {
  return data ? data.map((item) => ({
    code: item.code,
    name: item.name,
    fullName: item.fullName,
  })) : [];
}
